const spacer = 1;
const spacers = {
  0: 0,
  1: spacer / 8,
  2: spacer / 4,
  3: spacer / 2,
  4: spacer * 0.75,
  5: spacer * 1,
  6: spacer * 1.5,
  7: spacer * 2,
  8: spacer * 3,
  9: spacer * 4,
  10: spacer * 5,
  11: spacer * 6,
  12: spacer * 7,
  13: spacer * 8
};
export {
  spacer,
  spacers
};
//# sourceMappingURL=spacers.js.map
